import React from 'react';
import styled from 'styled-components';
import InfiniteLooper from '../Shared/InfiniteLooper';
import { BREAKPOINTS } from '../../styles/variables';

const RightLooper = () => {
  return (
    <RightLooperWr>
      <InfiniteLooper direction='up'>
        <LooperImgCont>
          <img src='/imgs/runningImg.png' alt='' draggable={false} />
        </LooperImgCont>
      </InfiniteLooper>
    </RightLooperWr>
  );
};

const RightLooperWr = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 50px;
  z-index: 99;
  @media ${BREAKPOINTS.laptop} {
    width: 3.47vw;
  }
  @media ${BREAKPOINTS.mobile} {
    width: 6.46vw;
  }
`;

const LooperImgCont = styled.div`
  width: 50px;
  height: 356px;
  img {
    width: 100%;
    height: 100%;
  }
  @media ${BREAKPOINTS.laptop} {
    width: 3.47vw;
    height: 24.72vw;
  }
  @media ${BREAKPOINTS.mobile} {
    width: 6.46vw;
    height: 38.96vw;
  }
`;

export default RightLooper;
